import { Box, styled } from "@mui/material";

export const CommandCardsContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
}));
